module.exports = __webpack_public_path__ + "img/biaoqian_wenwubaohudanwei.5d8b4dd8.png";